var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "#37352f",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.509 0 0 114.496 0 256C0 397.489 114.496 512 256 512C397.491 512 512 397.504 512 256C512 114.509 397.504 0 256 0ZM256 476.279C134.538 476.279 35.721 377.463 35.721 256C35.721 134.537 134.538 35.721 256 35.721C377.463 35.721 476.279 134.537 476.279 256C476.279 377.463 377.463 476.279 256 476.279Z",
    fill: "#37352f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248.425 323.924C234.272 323.924 222.815 335.718 222.815 349.87C222.815 363.687 233.935 375.818 248.425 375.818C262.915 375.818 274.371 363.687 274.371 349.87C274.371 335.718 262.577 323.924 248.425 323.924Z",
    fill: "#37352f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.805 127.469C207.313 127.469 186.421 154.428 186.421 172.624C186.421 185.766 197.541 191.832 206.639 191.832C224.836 191.832 217.423 165.884 251.794 165.884C268.642 165.884 282.122 173.298 282.122 188.799C282.122 206.995 263.251 217.441 252.131 226.876C242.358 235.299 229.554 249.116 229.554 278.096C229.554 295.618 234.272 300.673 248.087 300.673C264.598 300.673 267.968 293.26 267.968 286.856C267.968 269.334 268.305 259.225 286.839 244.735C295.937 237.659 324.579 214.744 324.579 183.069C324.579 151.394 295.937 127.469 252.805 127.469Z",
    fill: "#37352f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.79b41223503bd62a48f8afe40731babf.svg";
export { ForwardRef as ReactComponent };